import { useState, useEffect, useCallback } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import {
    fetchIsyerimPosSettings,
    upsertIsyerimPosSettings,
    deleteIsyerimPosSettings
} from "../../../api/requests/company-requests";

export const useIsyerimPosSettings = (companyId) => {
    const [loading, setLoading] = useState(false);
    const [hasSettings, setHasSettings] = useState(false);
    const [settingsId, setSettingsId] = useState(null);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            companyId: companyId || "",
            merchantId: "",
            userId: "",
            apiKey: "",
            testMode: false
        },
        validationSchema: Yup.object({
            companyId: Yup.string().required("Gerekli"),
            merchantId: Yup.string().required("Merchant ID gerekli"),
            userId: Yup.string().required("API Kullanıcı ID gerekli"),
            apiKey: Yup.string().required("API Anahtarı gerekli")
        }),
        onSubmit: async (values) => {
            setLoading(true);
            try {
                const payload = {
                    companyId: values.companyId,
                    merchantId: values.merchantId,
                    userId: values.userId,
                    apiKey: values.apiKey,
                    testMode: values.testMode
                };

                const res = await upsertIsyerimPosSettings(payload);
                if (res?.success || res?.data) {
                    setHasSettings(true);
                    if (res?.data?.id) setSettingsId(res.data.id);
                    toast.success("İşyerimPOS ayarları güncellendi");
                } else {
                    toast.error(res?.message || "İşyerimPOS ayarları kaydedilemedi");
                }
            } catch (error) {
                toast.error("İşyerimPOS ayarları kaydedilirken hata oluştu");
            } finally {
                setLoading(false);
            }
        }
    });

    useEffect(() => {
        if (!companyId) return;

        const loadSettings = async () => {
            try {
                const res = await fetchIsyerimPosSettings(companyId);

                if (res?.data) {
                    setHasSettings(true);
                    setSettingsId(res.data.id ?? null);
                    // Güvenlik: apiKey backend'den DÖNMEZ; boş bırakılır,
                    // güncelleme için tekrar girilmesi gerekir.
                    formik.setValues({
                        companyId,
                        merchantId: res.data.merchantId ?? "",
                        userId: res.data.userId ?? "",
                        apiKey: "",
                        testMode: res.data.testMode ?? false
                    });
                } else {
                    setHasSettings(false);
                    setSettingsId(null);
                }
            } catch (error) {
                console.error("İşyerimPOS ayarları yüklenemedi", error);
                setHasSettings(false);
                setSettingsId(null);
            }
        };

        loadSettings();
    }, [companyId]);

    // Bağlantıyı kaldır: backend'deki kaydı siler ama girilen form bilgilerini
    // olduğu gibi bırakır (tekrar bağlanmak isterse yeniden yazmasın diye).
    const disconnect = useCallback(async () => {
        if (!settingsId) {
            setHasSettings(false);
            return true;
        }
        try {
            const res = await deleteIsyerimPosSettings(settingsId);
            if (res?.statusCode === 200 || res?.data === true) {
                setHasSettings(false);
                setSettingsId(null);
                return true;
            }
            return false;
        } catch (error) {
            console.error("İşyerimPOS bağlantısı kaldırılamadı", error);
            return false;
        }
    }, [settingsId]);

    return { formik, loading, hasSettings, disconnect };
};
